<script setup lang="ts">
import { onMounted } from "vue";
import AppImage from "../../components/AppImage.vue";
import SiteHeader from "../../components/SiteHeader.vue";
import FooterLower from "../../components/FooterLower.vue";
import FooterModal from "../../components/FooterModal.vue";
import { useCommon } from "../../composables/useCommon";

const common = useCommon();

onMounted(() => {
  document.documentElement.classList.add("is-loaded");
});

const members = [
  {
    img: "/assets/company/img/kazuki_nakajima.png",
    alt: "中嶋 一樹",
    position: "代表取締役",
    name: "中嶋 一樹",
    text: "Salesforce、日本オラクル等でエバンジェリストとしてキャリアを重ね、前職のLINE在籍時に日本初のLINEを使った行政サービスとなる粗大ごみ申請（福岡市）の仕組みを実現。2019年に株式会社Bot Expressを創業。「お客様は住民、自治体はパートナー」という理念のもと、共鳴していただけるパートナーと最高の住民サービスを提供することをミッションとして事業を推進。趣味はキャンプ。",
  },
  {
    img: "/assets/company/img/akemi_matsuo.png",
    alt: "松尾 明美",
    position: "執行役員 PR部長",
    name: "松尾 明美",
    text: "Dell、LINEの親会社NAVER海外拠点を経て、前職はLINE国内第二拠点LINE Fukuokaにて、広報・採用組織を統括。企業広報・危機管理広報・PRマーケ、採用など担当。テクノロジーを活用した最高の住民サービスを提供し、日本の暮らしにもっと自由な時間を創ること、楽しくすることを、目指している。",
  },
  {
    img: "/assets/company/img/shoko_nishide.png",
    alt: "仁志出 彰子",
    position: "執行役員 営業部長",
    name: "仁志出 彰子",
    text: "23年勤めた前職の大津市役所では勤労福祉、情報システム、学校教育、保健予防、経営経理、経営戦略の業務に携わっていた。その経験を活かし、住民により便利な市役所サービスを提供するだけでなく、忙しい公務員を助けることができるBot Expressのサービスをたくさんの自治体に知ってほしいと思い営業として入社。",
  },
  {
    img: "/assets/company/img/yusuke_inui.png",
    alt: "乾 友輔",
    position: "パートナーサクセス部長",
    name: "乾 友輔",
    text: "リクルート、LINE Fukuoka、ROUTE06にて事業企画・プロダクトマネージャーとして従事。「日本の行政サービスのデファクトスタンダードを塗り替える」というミッションに惹かれ入社。パートナー自治体とともに、最高の住民サービス提供のあり方を考え、作っていきます。",
  },
  {
    img: "/assets/company/img/yuki_nakamura_v2.png",
    alt: "中村 優輝",
    position: "プロダクト開発部長",
    name: "中村 優輝",
    text: "クラスメソッド、LINEヤフーにてソフトウェアエンジニア・プロダクトマネージャー・ソリューションアーキテクトなどに従事。行政サービスのDXに惹かれ入社。GovTech Expressの提供を通じて、住民・パートナー自治体の「めんどくさい」をなくしていきます。",
  },
];

const openModal = (modalNum: number) => {
  common.isModalNum.value = modalNum;
  if (!common.isModalOpen.value) {
    common.modalToggle();
  }
};

const closeModal = () => {
  if (common.isModalOpen.value) {
    common.modalToggle();
  }
};
</script>

<template>
  <div
    class="be-wrapper"
    :class="{ 'is-menuopen': common.isMenuOpen.value }"
    v-cloak
  >
    <SiteHeader @toggle-menu="common.menuToggle" />

    <main id="be-content" class="be-content">
      <div class="be-breadcrumb">
        <div class="be-inner">
          <ul class="be-breadcrumb-list">
            <li class="be-breadcrumb-list__li"><a href="/">TOP</a></li>
            <li class="be-breadcrumb-list__li">会社概要</li>
          </ul>
        </div>
      </div>
      <div class="be-pagetitle">
        <div class="be-inner">
          <h1 class="be-pagetitle__title js-scrollfade">
            <span class="font-en"><small>○ </small>Company</span
            ><span class="be-pagetitle__title__sub">会社概要</span>
          </h1>
        </div>
      </div>

      <div class="be-company">
        <div class="be-inner be-company__inner">
          <div class="be-company-hero">
            <div class="be-company-hero__desc js-scrollfade">
              生きることと夢を追うこと。<br
                class="be-hidden-pc"
              />仕事と子育て。<br />
              大切なものがたくさんある人ほど、<br />
              いつもなにかをあきらめながら<br
                class="be-hidden-pc"
              />生きているこの国で。<br />
              <br />
              忙しいみんなが欲しかった、<br
                class="be-hidden-pc"
              />あと１分をつくるために。<br />
              なにより、<br
                class="be-hidden-pc"
              />「めんどくさい」という理由で、<br />
              町のサポートが必要な人が<br
                class="be-hidden-pc"
              />躊躇してしまわないように。<br />
              <br />
              生活に必要な手続きや連絡、予約といった<br />
              毎日の些細な面倒と向き合い、<br />
              デジタルであるべき簡単さに変えていく。<br />
              <br />
              町のすべてのため息を、<br />
              町がもっとよくなるチャンスにする。<br />
              それが、Bot Expressの挑戦です。
            </div>
            <div class="be-company-hero__main js-scrollfade">
              <picture>
                <source
                  srcset="/assets/company/img/hero-main_sp.svg"
                  media="(max-width: 768px)"
                  width="375"
                  height="217"
                />
                <source
                  srcset="/assets/company/img/hero-main_pc.svg"
                  media="(min-width: 769px)"
                  width="1376"
                  height="70"
                />
                <img
                  src="/assets/company/img/hero-main_sp.svg"
                  alt="世界からめんどくさいをなくせ。"
                  width="375"
                  height="217"
                  class="be-resize"
                />
              </picture>
            </div>
          </div>

          <div class="be-company-section">
            <div class="be-company-overview">
              <div class="be-company-overview__l">
                <h2 class="be-subtitle js-scrollfade">
                  <i style="background-color: rgb(11, 100, 70)"></i
                  ><span>会社概要</span>
                </h2>
              </div>
              <div class="be-company-overview__r">
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">会社名</div>
                  <div class="be-company-dl__dd">
                    株式会社Bot Express（ボットエクスプレス）
                  </div>
                </div>
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">住所</div>
                  <div class="be-company-dl__dd">
                    〒105-6923　<br class="be-hidden-pc" />東京都港区虎ノ門4-1-1
                    神谷町トラストタワー23階
                  </div>
                </div>
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">代表取締役</div>
                  <div class="be-company-dl__dd">中嶋 一樹</div>
                </div>
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">設立日</div>
                  <div class="be-company-dl__dd">2019年02月01日</div>
                </div>
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">資本金</div>
                  <div class="be-company-dl__dd">1億円</div>
                </div>
                <div class="be-company-dl js-scrollfade">
                  <div class="be-company-dl__dt">事業内容</div>
                  <div class="be-company-dl__dd">
                    官公庁専用対話型アプリケーション<br
                      class="be-hidden-pc"
                    />「GovTech Express」の開発提供
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="be-company-section">
            <h2 class="be-subtitle js-scrollfade">
              <i style="background-color: rgb(11, 100, 70)"></i
              ><span>Leaders</span>
            </h2>
            <div
              v-for="(member, index) in members"
              :key="member.name"
              class="be-company-member"
              :class="`be-company-member0${(index % 3) + 1}`"
            >
              <div class="be-company-member__thumb js-scrollfade">
                <AppImage
                  :src="member.img"
                  :alt="member.alt"
                  width="480"
                  height="480"
                  class="be-resize"
                />
              </div>
              <div class="be-company-member__content">
                <p class="be-company-member__position js-scrollfade">
                  {{ member.position }}
                </p>
                <p class="be-company-member__name js-scrollfade">
                  {{ member.name }}
                </p>
                <p class="be-company-member__text js-scrollfade">
                  {{ member.text }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <FooterLower @open-modal="openModal" />
    <FooterModal
      :is-open="common.isModalOpen.value"
      :modal-num="common.isModalNum.value"
      @close="closeModal"
    />
  </div>
</template>
